import { REDUCER_NAMES } from 'js/app/store/constants';
import { useCustomSelector } from 'js/store/hooks/useCustomSelector';

export const useClubsSelector = (selector, equalityFn) =>
    useCustomSelector(REDUCER_NAMES.clubs, selector, equalityFn);
